import { render, staticRenderFns } from "./Limitations.vue?vue&type=template&id=08bfd9a9&scoped=true&"
import script from "./Limitations.vue?vue&type=script&lang=js&"
export * from "./Limitations.vue?vue&type=script&lang=js&"
import style0 from "./Limitations.vue?vue&type=style&index=0&id=08bfd9a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfd9a9",
  null
  
)

export default component.exports